export default __webpack_public_path__ + "static/media/cancelledIcon.babb3af9.svg";